<template>
  <div class="contactUs-page">
    <!-- 关于我们 -->
    <div class="banner-container">
      <div class="haeder-container">
        <Header></Header>
        <Nav></Nav>
      </div>
      <div class="info-container">
        <img src="../../assets/img/contactUs/banner_bg.png" alt="" class="banner_bg">
        <div class="info-content-container">
          <p class="title">百倍云科技</p>
        </div>
      </div>
    </div>
    <div class="plate1">
      <p class="first-title">联系我们</p>
      <!-- <img src="../../assets/img/contactUs/mapl.jpg" alt="" class="banner_bg"> -->
      <div class="contactUs-way-item">
        <div class="contactUs-way-item-left">
          <div class="contactUs-way-item-top contactUs-way-item-top1">
            <img class="logo-icon logo-icon1" src="../../assets/img/contactUs/logo.png" alt="">
            <p class="contactUs-name contactUs-name1">百倍云</p>
            <p class="contactUs-describe">数字化、智能化创新团队</p>
          </div>
          <ul class="contactUs-way-list-container">
            <li class="contactUs-way-item-container">
              <span class="contactUs-way-list-name">技术咨询</span>
              <span class="contactUs-way-res">133-8842-9226</span>
            </li>
            <li class="contactUs-way-item-container">
              <span class="contactUs-way-list-name">商务咨询</span>
              <span class="contactUs-way-res">133-7255-9097</span>
            </li>
            <li class="contactUs-way-item-container">
              <span class="contactUs-way-list-name">微信交流</span>
              <span class="contactUs-way-res">139-6718-5427</span>
            </li>
             <li class="contactUs-way-item-container"  v-if="!shownav">
              <span class="contactUs-way-list-name">联系地址</span>
              <span class="contactUs-way-res">杭州(中国)人工智能小镇 12幢907室</span>
            </li>
          </ul>
          <img class="watermark_img" src="../../assets/img/contactUs/watermark_img1.png" alt="">
        </div>
        <div class="contactUs-way-item-right">
          <img class="map-img" src="../../assets/img/contactUs/map_img1.png" alt="">
        </div>
      </div>
      <div class="contactUs-way-item" v-if="shownav">
        <div class="contactUs-way-item-left">
          <div class="contactUs-way-item-top contactUs-way-item-top2">
            <img class="logo-icon logo-icon2" src="../../assets/img/contactUs/logo2.png" alt="">
            <p class="contactUs-name">浙江大学</p>
            <p class="contactUs-describe">工业技术研究院</p>
          </div>
          <ul class="contactUs-way-list-container">
             <li class="contactUs-way-item-container">
              <span class="contactUs-way-list-name">技术咨询</span>
              <span class="contactUs-way-res">133-8842-9226</span>
            </li>
            <li class="contactUs-way-item-container">
              <span class="contactUs-way-list-name">商务咨询</span>
              <span class="contactUs-way-res">133-7255-9097</span>
            </li>
            <li class="contactUs-way-item-container">
              <span class="contactUs-way-list-name">微信交流</span>
              <span class="contactUs-way-res">139-6718-5427</span>
            </li>

          </ul>
          <img class="watermark_img" src="../../assets/img/contactUs/watermark_img2.png" alt="">
        </div>
        <div class="contactUs-way-item-right">
          <img class="map-img" src="../../assets/img/contactUs/map_img2.png" alt="">
        </div>
      </div>
            <div class="contactUs-way-item" v-if="shownav">
        <div class="contactUs-way-item-left">
           <div class="contactUs-way-item-top contactUs-way-item-top1">
            <img class="logo-icon logo-icon1" src="../../assets/img/contactUs/logo.png" alt="">
            <p class="contactUs-name contactUs-name1">百倍云</p>
            <p class="contactUs-describe">智能设备</p>
          </div>
          <ul class="contactUs-way-list-container">
             <li class="contactUs-way-item-container">
              <span class="contactUs-way-list-name">技术咨询</span>
              <span class="contactUs-way-res">133-8842-9226</span>
            </li>
            <li class="contactUs-way-item-container">
              <span class="contactUs-way-list-name">商务咨询</span>
              <span class="contactUs-way-res">133-7255-9097</span>
            </li>
            <li class="contactUs-way-item-container">
              <span class="contactUs-way-list-name">微信交流</span>
              <span class="contactUs-way-res">139-6718-5427</span>
            </li>
          </ul>
          <!-- <img class="watermark_img" src="../../assets/img/contactUs/watermark_img2.png" alt=""> -->
        </div>
        <div class="contactUs-way-item-right">
          <img class="map-img" src="../../assets/img/contactUs/map3.png" alt="">
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'

export default {
  name: 'contactUs',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {
      shownav:false,
    }
  },
  mounted() {
    let that = this
    this.changetitle()
  },
    methods: {
          changetitle(){//http://www.100byun.com  http://100byun.com使用这个域名访问官网时，底部的备案信息需要更换下，其它访问方式时，底部备案信息还是跟当前一样不变
    var url = window.location.href
     this.shownav = true
    // if(url.split("/#/")[0] == "http://www.100byun.com"||url.split("/#/")[0] == "http://100byun.com"){
    //   this.shownav = false
    // }else{
    //   this.shownav = true
        
    // }
    },
  }
}

</script>
<style lang="scss">
  
</style>